import { createIcon } from "@chakra-ui/icons";

// Created from move-map.svg

export const MoveMapIcon = createIcon({
  displayName: "Move map",
  viewBox: "0 0 16 15",
  path: (
    <g fill="none">
      <path
        d="M1.47723 3.54546V13L5.6136 10.6364L10.3409 13L14.4772 10.6364V1.18182L10.3409 3.54546L5.6136 1.18182L1.47723 3.54546Z"
        stroke="#69A0C9"
        strokeWidth="0.886364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.61365 1.18182V10.6364"
        stroke="#69A0C9"
        strokeWidth="0.886364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3409 3.54547V13"
        stroke="#69A0C9"
        strokeWidth="0.886364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31799 3.67922C5.49702 3.50041 5.78741 3.50039 5.96643 3.67922L9.20276 6.91652L8.55432 7.56496L8.55139 7.56105L5.96448 10.1489C5.78547 10.328 5.49513 10.3278 5.31604 10.1489C5.13697 9.96987 5.13697 9.67958 5.31604 9.50051L7.31995 7.4966H1.47717C1.15086 7.49655 0.886353 7.2321 0.886353 6.90578C0.886488 6.57957 1.15095 6.31501 1.47717 6.31496H7.30432L5.31799 4.32765C5.1391 4.14857 5.13898 3.85823 5.31799 3.67922Z"
        fill="#69A0C9"
      />
    </g>
  ),
});
